import React, { useEffect, useState, useRef } from "react";

import { useParams, useHistory } from "react-router-dom";
import DOMPurify from "dompurify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getCopilotMultimodalStream } from "../../../../../services/staffingService";
import gfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import conversationHistory from "./conversationHistory.json";
// import HandsOnTable from "./handsOnTable";

// import ShareIcon from "@mui/icons-material/Share";
import { Copy, Maximize2, Bot } from 'lucide-react';
import { Editor } from "@tinymce/tinymce-react";

import Send from "../../../../_asset/img/send-2.svg";
// import Rectangle from "../../../../_asset/img/Rectangle.svg";
import { ReactComponent as Magicpen } from "../../../../_asset/img/magicpen.svg";
import Paperclip from "../../../../_asset/img/paperclip-2.png";

const schema = yup
  .object({
    prompt: yup
      .string()
      .required("Prompt is required")
      .max(3200, "Max length exceeded"),
  })
  .required();

const Copilot = () => {
  const [loading, setLoading] = useState(false);

  const [conversation, setConversation] = useState([]);

  const [prompt, setPrompt] = useState("");
  const [completion, setCompletion] = useState("");
  const [completionLoading, setCompletionLoading] = useState(false);
  const [completionError, setCompletionError] = useState(true);

  const [showFullscreen, setShowfullscreen] = useState(false);

  const [completionSettingsExists, setCompletionSettingsExists] = useState(false);
  const [fileId, setFileId] = useState("");
  const [sourceBlob, setSourceBlob] = useState("");
  const [asset, setAsset] = useState("");
  const [assetSaved, setAssetSaved] = useState(false);
  const [err, setErr] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lastwords, setLastwords] = useState("");
  const [df, setDf] = useState([]);

  const chatContainerRef = useRef(null);
  const chatEndRef = useRef(null);
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const editorRef = useRef(null);

  const hotRef = React.useRef(null);

  useEffect(() => {
    const fetchModelDetails = async () => {
      try {
        setLoading(true);
        let resp2 = conversationHistory;
        let convHistory = [];
        resp2.data.conv.forEach((item) => {
          item.choices.forEach((choice) => {
            convHistory.push(choice.message);
          });
        });
        setConversation([...convHistory]);
        setAsset(resp2.data.asset.content);
        setPrompt("resp_card.data.prompt");
        setLoading(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          history.push("/404");
        }
      }
    };
    fetchModelDetails();
  }, [history]);

  useEffect(() => {
    const codeElements = document.querySelectorAll(
      '.junior-analyst-chatBox .junior-analyst-msg p > pre > code[class^="language-"]'
    );
    codeElements.forEach((el) => {
      const langMatch = el.className.match(/language-(\w+)/);
      if (langMatch && langMatch[1]) {
        el.parentElement.setAttribute("data-lang", langMatch[1]);
      }
    });
  }, [conversation]);

  const onSubmit = async (data) => {
    console.log("submitted +++++++ prompt +++++ ", data);
    setErr("");
    setCompletionLoading(true);
    try {
      setConversation((prevConversation) => [
        ...prevConversation,
        // { role: 'user', content: formatRange(selectedRange[0]) , range: selectedRange , menu: menu, submenu:(submenu?submenu:prompt)}
        { role: "user", content: data.prompt },
      ]);
      const resp = await getCopilotMultimodalStream(data.prompt);


     if (!resp.ok || !resp.body) {
        setCompletionError(true);
        setConversation((prevConversation) => [
            ...prevConversation,
            { role: "assistant", content: resp.data.errmessage, err: true },
        ]);
        setCompletionLoading(false);
        reset();
        throw resp.statusText;
       }

      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      const loopRunner = true;
      let result = "";

      while (loopRunner) {
        const { value, done } = await reader.read();
        if (done) {
          break;
        }
        const decodedChunk = decoder.decode(value, { stream: true });
        let compl = decodedChunk;
        result += compl;

        setLastwords(result);
        reset();
      }
      setLastwords("");
      setCompletion(result);
      setPrompt(data.prompt);
      setCompletionLoading(false);
      setConversation((prevConversation) => [
        ...prevConversation,
        { role: "assistant", content: result },
      ]);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        setErr(ex.response.data);
      }
      setCompletionLoading(false);
      //setHighlightedRanges([])
    }
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView();
    }
  }, [conversation, lastwords]);

  const toggleModal = () => {
    setIsModalOpen((prevState) => !prevState);
  };

  const handleFullscreen = (content) => {
    const serializedConversation = encodeURIComponent(JSON.stringify(content));
    // const serializedConversation = encodeURIComponent(JSON.stringify(conversation));
    // window.open(`/chatbox/fullscreen?conversation=${serializedConversation}`, '_blank');
    window.open(
      `/copilot/junior-analyst/response/full-screen?conversation=${serializedConversation}`,
      "_blank"
    );
  };

  return (
    <>
      <div className="h-full p-6 overflow-y-auto">
        <div className={`mx-auto ${conversation.length > 0 ? 'w-full' : 'w-3/5'} ${conversation.length === 0 ? 'h-[calc(100%-204px)] flex flex-col justify-center' : ''}`}>
          
          {!conversation.length && (
            <>
              <div className="w-10 h-10 rounded-lg bg-pink-50 p-2 mx-auto mb-4">
                <Magicpen />
              </div>
              <p className="text-gray-600 text-center text-xs font-normal leading-4 m-0">
                Ask me anything about the service level agreements with this
                customer.
              </p>
            </>
          )}

          {conversation.length > 0 && (
            <div className="flex-1 mt-2 overflow-y-auto">
              {conversation.map((item, index) => (
                <React.Fragment key={index}>
                  {item.role === "user" && (
                    <div className="border border-pink-100 p-3 rounded-2xl flex items-start mb-4 bg-pink-50 w-4/5 ml-auto relative">
                      <p className="text-gray-800 text-xs font-medium m-0">{item.content}</p>
                    </div>
                  )}
                  {item.role === "assistant" && !item.err && (
                    <div className="border border-gray-200 p-4 rounded-2xl flex items-start mb-4 bg-gray-50 relative">
                      <Bot
                        style={{
                          color: "#49527f",
                          fontSize: "35px",
                          marginRight: "14px",
                        }}
                      />
                      <div className="flex-grow">
                        <div className="text-gray-800 text-xs font-medium">
                          <ReactMarkdown
                            children={item.content}
                            remarkPlugins={[gfm]}
                            components={{
                              code({node, inline, className, children, ...props}) {
                                const match = /language-(\w+)/.exec(className || '')
                                return !inline && match ? (
                                  <div className="relative max-w-[90%] overflow-x-auto my-2 rounded-lg bg-pink-300 pt-4">
                                    <div className="absolute top-1 right-1 bg-pink-400 bg-opacity-70 text-white rounded px-1.5 py-0.5 text-xs font-medium z-10">
                                      {match[1]}
                                    </div>
                                    <pre className="block text-white p-3 whitespace-pre-wrap leading-6" {...props}>
                                      <code>{children}</code>
                                    </pre>
                                  </div>
                                ) : (
                                  <code className="inline bg-pink-200 px-1 py-0.5 rounded text-xs font-mono" {...props}>
                                    {children}
                                  </code>
                                )
                              },
                              table({children}) {
                                return (
                                  <table className="text-sm mt-8 mb-8 table-auto text-left border-separate border-spacing-0">
                                    {children}
                                  </table>
                                )
                              },
                              th({children}) {
                                return (
                                  <th className="font-bold text-left bg-pink-200 p-3 border border-gray-200">
                                    {children}
                                  </th>
                                )
                              },
                              td({children}) {
                                return (
                                  <td className="p-3 border border-gray-200 bg-gray-50">
                                    {children}
                                  </td>
                                )
                              },
                              h1: ({children}) => <h1 className="text-sm font-bold underline my-5">{children}</h1>,
                              h2: ({children}) => <h2 className="text-sm font-bold underline my-5">{children}</h2>,
                              h3: ({children}) => <h3 className="text-sm font-bold underline my-5">{children}</h3>,
                              h4: ({children}) => <h4 className="text-xs font-bold underline my-5">{children}</h4>,
                              h5: ({children}) => <h5 className="text-xs font-bold underline my-5">{children}</h5>,
                              h6: ({children}) => <h6 className="text-xs font-bold underline my-5">{children}</h6>,
                              p: ({children}) => <p className="my-4 text-xs leading-6">{children}</p>,
                              ul: ({children}) => <ul className="my-4 pl-5 text-xs list-disc">{children}</ul>,
                              ol: ({children}) => <ol className="my-4 pl-5 text-xs list-decimal">{children}</ol>,
                              img: ({src, alt}) => <img src={src} alt={alt} className="max-w-[70%] h-auto mr-3 block mb-2 rounded-lg shadow-sm" />
                            }}
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          handleFullscreen(item.content);
                        }}
                        className="absolute -bottom-2 left-[7%] px-2 py-1 bg-pink-500 text-white border-none cursor-pointer rounded h-4 flex items-center justify-center text-xs hover:bg-pink-600 transition-colors"
                      >
                        <Maximize2
                          style={{ fontSize: "16px", color: "white" }}
                        />
                      </button>
                      <button
                        type="button"
                        className="absolute -bottom-2 left-[17%] px-2 py-1 bg-pink-500 text-white border-none cursor-pointer rounded h-4 flex items-center justify-center text-xs ml-2 hover:bg-pink-600 transition-colors"
                      >
                        <Copy
                          style={{ fontSize: "14px", color: "white" }}
                        />
                      </button>
                    </div>
                  )}
                  {item.role === "assistant" && item.err && (
                    <div className="text-center mb-2">
                      <p className="text-red-500 text-xs">{item.content}</p>
                    </div>
                  )}
                </React.Fragment>
              ))}
              {lastwords && (
                <div className="border border-gray-200 p-4 rounded-2xl flex items-start mb-4 bg-gray-50">
                  <Bot
                    style={{
                      color: "#1470B7",
                      fontSize: "40px",
                      marginRight: "14px",
                    }}
                  />
                  <div className="text-gray-800 text-xs font-medium">
                    <ReactMarkdown
                      children={lastwords}
                      remarkPlugins={[gfm]}
                    />
                  </div>
                </div>
              )}
              <div ref={chatEndRef}></div>
            </div>
          )}
        </div>
        
        {!completionLoading && (
          <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
            <div className="rounded-lg border border-gray-200 bg-white p-4">
              <textarea
                type="text"
                {...register("prompt")}
                rows={3}
                placeholder="Ask AI"
                className="form-textarea w-full border-none resize-none shadow-none outline-none text-sm"
              />
              {errors.prompt && (
                <span className="form-error text-xs mt-1 block">
                  {errors.prompt.message}
                </span>
              )}
              <div className="flex items-center justify-end mt-2">
                <button 
                  type="submit"
                  className="rounded-lg bg-gray-500 hover:bg-gray-600 px-3 py-2 text-white text-xs font-normal leading-4 transition-colors"
                >
                  Ask
                </button>
              </div>
            </div>
          </form>
        )}

        {completionLoading && (
          <div className="text-center mt-4 flex items-center justify-center">
            <div className="animate-pulse bg-blue-500 rounded-full h-2 w-2 mr-3"></div>
            <div className="animate-pulse bg-blue-500 rounded-full h-2 w-2 mr-3" style={{animationDelay: '0.1s'}}></div>
            <div className="animate-pulse bg-blue-500 rounded-full h-2 w-2" style={{animationDelay: '0.2s'}}></div>
          </div>
        )}
      </div>
    </>
  )
};

export default Copilot;
